import { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';

import { setUserLocation, setSearchBounds } from '../graphql/ecp-locator/ecp-locator.cache';

interface IUpdateUserLocation {
  searchValue: string;
  uri?: string;
}

export const useSearchLocation = () => {
  const userLocationCurrent = useReactiveVar(setUserLocation);

  const updateLocationCoordinates = useCallback(async ({ searchValue, uri }: IUpdateUserLocation) => {
    let userLocation = userLocationCurrent;

    const baseUrl = `${process.env.REACT_APP_YANDEX_GEOCODING_BASE_URL}?apikey=${process.env.REACT_APP_YANDEX_MAPS_AK}&format=json`;
    const url = uri
      ? `${baseUrl}&uri=${encodeURIComponent(uri)}`
      : `${baseUrl}&geocode=${encodeURIComponent(searchValue)}`;
    const res = await fetch(url);

    if (res.ok) {
      const data = await res.json();
      const members = data?.response?.GeoObjectCollection?.featureMember;
      const geoObject = members?.[0]?.GeoObject;
      const pos = geoObject?.Point?.pos;

      if (pos) {
        const [lonStr, latStr] = pos.split(' ');
        userLocation = {
          latitude: Number(latStr),
          longitude: Number(lonStr),
        };

        const envelope = geoObject?.boundedBy?.Envelope;
        if (envelope?.lowerCorner && envelope?.upperCorner) {
          const [minLon, minLat] = envelope.lowerCorner.split(' ').map(Number);
          const [maxLon, maxLat] = envelope.upperCorner.split(' ').map(Number);

          if ([minLon, minLat, maxLon, maxLat].every(Number.isFinite)) {
            setSearchBounds([[minLon, minLat], [maxLon, maxLat]]);
          }
        }
      }
    }

    return userLocation;
  }, [userLocationCurrent]);

  return { updateLocationCoordinates };
};
